<template>
  <div>
    <vDialog v-model="dialogVisible" width="fit-content" persistent>
      <v-card class="checkout-modal-container">
        <div class="header-modal">
          <div class="title-modal">
            <div class="headline-s">
              {{ title }}
            </div>
          </div>
          <button class="btn-close" @click="closeModalAndRedirect">
            <v-icon class="icon-close">
              mdi-close
            </v-icon>
          </button>
        </div>

        <template v-if="!isVip()">
          <div class="ship-date-container" v-if="shippingDate">
            <div class="ship-date-body">
              <div class="ship-date-icon">
                <div class="wind"></div>
                <img
                  src="@/assets/icon/icon-truck.svg"
                  class="icon-truck"
                />
                <div class="street"></div>
              </div>
              <div class="ship-date-content">
                <template v-for="(seg, i) in segments">
                  <!-- <br :key="i" v-if="seg.isDate" /> -->
                  <span :key="i" :class="{ 'is-date': seg.isDate }">{{
                    seg.text
                  }}</span>
                </template>
              </div>
            </div>
          </div>

          <!-- Display slot -->
          <div
            class="slot-table-container"
            v-if="slotTable && slotTable.length"
          >
            <div class="title-semibold slot-table-title">
              รอบสินค้า
            </div>
            <div class="slot-table-list">
              <div
                class="slot-table-item"
                :class="{ 'is-full': !item.current }"
                v-for="item in slotTable"
                :key="item.date"
              >
                <span class="body-s slot-table-message">
                  {{ item.message }}
                </span>
                <span
                  v-if="item.current"
                  class="body-s-semibold slot-table-status is-current"
                >
                  <v-icon size="16" color="#5BBA47">
                    mdi-check-circle
                  </v-icon>
                  รอบที่คุณได้
                </span>
                <span
                  v-else
                  class="body-s-semibold slot-table-status is-full"
                >
                  เต็มแล้ว
                </span>
              </div>
            </div>
          </div>
        </template>

        <div
          :class="['checkout-modal-content', { 'is-vip': isVip() }]"
        >
          <div v-if="desc" v-html="desc" class="body-s pt-2"></div>

          <slot></slot>
        </div>

        <div class="checkout-modal-footer">
          <slot name="footer"></slot>
        </div>
      </v-card>
    </vDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CheckoutModalConfirmOrder',
  inject: ['isVip'],
  props: {
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    shippingDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      isLoading: state => state.staticPage.isLoading,
      staticPageDataHtml: state =>
        state.staticPage.data?.[0]?.html ?? '',
      slotTable: state => state.order.data?.slot_table ?? [],
    }),
    segments() {
      const detectDate = /(\d{2}\/\d{2}\/\d{4})/g
      const detectFullDate = /(\d{1,2})\s(\S+)\s(\d{2,4})/g

      const result = []
      let lastIndex = 0

      const allMatches = []

      // collect all matches for both patterns
      for (const match of this.shippingDate.matchAll(detectDate)) {
        allMatches.push({
          index: match.index,
          text: match[0],
          isDate: true,
          length: match[0].length,
        })
      }

      for (const match of this.shippingDate.matchAll(
        detectFullDate,
      )) {
        allMatches.push({
          index: match.index,
          text: match[0],
          isDate: true,
          length: match[0].length,
        })
      }

      // sort matches by index to handle mixed order
      allMatches.sort((a, b) => a.index - b.index)

      for (const match of allMatches) {
        if (match.index > lastIndex) {
          result.push({
            text: this.shippingDate.slice(lastIndex, match.index),
            isDate: false,
          })
        }
        result.push({
          text: match.text,
          isDate: true,
        })
        lastIndex = match.index + match.length
      }

      // Add remaining text after last match
      if (lastIndex < this.shippingDate.length) {
        result.push({
          text: this.shippingDate.slice(lastIndex),
          isDate: false,
        })
      }

      return result
    },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  async mounted() {},
  methods: {
    openModal() {
      this.dialogVisible = true
    },
    closeModal() {
      this.dialogVisible = false
    },
    closeModalAndRedirect() {
      this.dialogVisible = false
      this.$router.push({
        name: 'ProductDetail',
        params: {
          slug: this.$route.params.slug,
        },
        query: {
          ...this.$route.query,
        },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
::v-deep .v-dialog {
    border-radius 18px
    border: 2px solid $color-bnn

    overflow-x hidden
    max-height 95dvh
    // overflow-y auto
    margin 0 0

    background-color white

    @media screen and (min-width: 768px) {
        margin 0
    }

    @media screen and (min-width: 1024px) {
        margin 0
    }
}

.checkout-modal-container {
    margin 0 auto !important
    position relative

    padding: 0
    border-radius: 18px

    width 90dvw
    max-width 100dvw
    min-width 90dvw
    position relative

    display flex
    flex-direction column

    box-shadow none !important

    @media screen and (min-width: 768px) {
        width 90dvw
        min-width 425px
        max-width 425px
    }

    @media screen and (min-width: 1280px) {
        // width 100%
        // max-width 1029px
        // min-width 1029px
    }

}

.checkout-modal-content {
    width 100%
    height fit-content
    min-height 500px
    overflow-y auto
    padding 0 16px

	&.is-vip {
		min-height 0
	}
}

.header-modal {
    position sticky
    top 0
    width 100%
    display: flex
    justify-content: space-between
	gap: 8px
    align-items: center
    background white
    z-index 10
    padding 24px 16px 0
    // box-shadow 0 0px 12px 16px white
    // margin-bottom: 16px
}

.btn-close {
    width: 40px;
    min-width: 40px;
    height: 40px;
    min-height: 40px;

    background: #e8e8e8;
    border-radius: 50% !important;

    z-index 10

    &:hover {
        .icon-close {
            color: rgba(0,0,0,0.72)
        }
    }

    &:focus {
        outline: .125rem solid #0071e3;
        outline-offset: .125rem;
        outline-offset: .125rem;
    }

    .icon-close {
        color: rgba(18,18,18,0.56)
    }
}

.checkout-modal-footer {
    position sticky
    bottom 0
    width 100%
    background white
    padding 16px 16px 24px
    z-index 10
}

.ship-date-container {
	margin-top: 16px;
	color: white !important;
	padding: 0 16px;

    .ship-date-body {
        display: flex;
        align-items: center;

        background: linear-gradient(120deg, #52a24c 0%, #7fda6c 100%);

        gap: 16px;
        padding: 8px 16px;
        border-radius: 8px;

        .ship-date-icon {
            width: 36px;
            height: 36px;
            flex: none;
            overflow: hidden;
            position relative

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .icon-truck {
                width: 85%;
                height: auto;
                animation: car-run 1s linear infinite;
            }

            .wind {
                position absolute
                top 38%
                left 5%
                width: 35%

                height: 3px
                border-radius: 6px
                overflow: hidden

                &:before {
                    content: ''
                    display: block
                    height: 100%
                    border-radius: 6px
                    background: white
                    animation: line-right-to-left 1.2s linear infinite
                }

            }

            .street {
                width: 100%
                height: 3px
                border-radius: 6px
                overflow: hidden

                &:before {
                    content: ''
                    display: block
                    height: 100%
                    border-radius: 6px
                    background: white
                    animation: line-right-to-left 1s linear infinite
                }

            }
        }

        .ship-date-content {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;

            font-size: 16px;
            line-height: 26px;
            font-weight: bold !important;

            .is-date {
                display: inline-block;
                font-weight: 700 !important;
                font-size: clamp(22px, 4.5vw, 24px);
            }
        }
    }


}

.slot-table-container {
    margin-top: 16px;
    padding: 0 16px;

    .slot-table-title {
        margin-bottom: 8px;
    }

    .slot-table-list {
        border: 1px solid $color-gray85;
        border-radius: 8px;
        overflow: hidden;
    }

    .slot-table-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 16px;

        &:not(:first-child) {
            border-top: 1px solid $color-gray85;
        }

		&.is-full {
			background-color: #F9F9F9;
			color: rgba(0, 0, 0, 0.45);
		}
    }

    .slot-table-status {
        flex: none;
        display: flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;

        &.is-full {
            color: $color-red;
        }

        &.is-current {
            color: $color-green;
        }
    }
}

@keyframes car-run {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(2px);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes line-right-to-left {
    0% {
        transform: translateX(100%)
        opacity 1
        width 100%
    }
    100% {
        transform: translateX(-100%)
        opacity 0
        width 0%
    }
}
</style>
